// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const SWITCH_CURRENCY = "switch-currency";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

//Contact Module const

export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";

export const FETCH_ALL_CONTACT = "fetch_all_contact";
export const FETCH_ALL_CONTACT_SUCCESS = "fetch_all_contact_success";
export const ADD_FAVOURITE = "add_favourite";
export const ON_CONTACT_SELECT = "on_contact_select";
export const ON_ADD_CONTACT = "on_add_contact";
export const ON_CONTACT_CLOSE = "on_contact_close";
export const ON_FILTER_OPTION_SELECT = "on_filter_option_select";
export const ON_SAVE_CONTACT = "on_save_contact";
export const ON_DELETE_CONTACT = "on_delete_contact";
export const ON_DELETE_SELECTED_CONTACT = "on_delete_selected_contact";
export const FILTER_CONTACT = "filter_contact";
export const GET_ALL_CONTACT = "get_all_contact";
export const GET_UNSELECTED_ALL_CONTACT = "get_unselected_all_contact";
export const ON_ALL_CONTACT_SELECT = "on_all_contact_select";
export const UPDATE_SEARCH_USER = "update_search_user";
export const ON_TOGGLE_DRAWER = "on_toggle_drawer";
export const HANDLE_REQUEST_CLOSE = "handle_request_close";
export const HIDE_CONTACT_LOADER = "hide_contact_loader";

//Auth const
export const SIGNUP_USER = "signup_user";
export const SIGNUP_USER_SUCCESS = "signup_user_success";
export const SIGNIN_GOOGLE_USER = "signin_google_user";
export const SIGNIN_GOOGLE_USER_SUCCESS = "signin_google_user_success";
export const SIGNIN_FACEBOOK_USER = "signin_facebook_user";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "signin_facebook_user_success";
export const SIGNIN_TWITTER_USER = "signin_twitter_user";
export const SIGNIN_TWITTER_USER_SUCCESS = "signin_twitter_user_success";
export const SIGNIN_GITHUB_USER = "signin_github_user";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_SUCCESS";
export const SIGNIN_USER = "signin_user";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNOUT_USER = "signout_user";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";
export const INIT_URL = "init_url";

// Chat Module const

export const FETCH_ALL_CHAT_USER = "fetch_all_chat_user";
export const FETCH_ALL_CHAT_USER_CONVERSATION =
  "fetch_all_chat_user_conversation";
export const FETCH_ALL_CHAT_USER_SUCCESS = "fetch_all_chat_user_success";
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS =
  "fetch_all_chat_user_conversation_success";
export const FILTER_USERS = "filter_users";
export const ON_SELECT_USER = "on_select_user";
export const ON_SHOW_LOADER = "on_show_loader";
export const ON_HIDE_LOADER = "on_hide_loader";
export const USER_INFO_STATE = "user_info_state";
export const SUBMIT_COMMENT = "submit_comment";
export const UPDATE_MESSAGE_VALUE = "update_message_value";
export const UPDATE_SEARCH_CHAT_USER = "update_search_chat_user";

//// Mail Module const

export const ADD_LABEL = "ADD_LABEL";
export const GET_ALL_MAIL = "get_all_mail";
export const FETCH_ALL_MAIL = "fetch_all_mail";
export const FETCH_ALL_MAIL_SUCCESS = "fetch_all_mail_success";
export const GET_IMPORTANT_MAIL = "get_important_mail";
export const GET_NAV_FILTERS = "get_nav_filters";
export const GET_NAV_LABELS = "get_nav_labels";
export const GET_NAV_FOLDER = "get_nav_folder";
export const GET_READ_MAIL = "get_read_mail";
export const GET_STARRED_MAIL = "get_starred_mail";
export const GET_UNIMPORTANT_MAIL = "get_unimportant_mail";
export const GET_UNREAD_MAIL = "get_unread_mail";
export const GET_UNSELECTED_ALL_MAIL = "get_unselected_all_mail";
export const GET_UNSTARRED_MAIL = "get_unstarred_mail";
export const ON_ALL_MAIL_SELECT = "on_all_mail_select";
export const ON_FOLDER_MENU_ITEM_SELECT = "on_folder_menu_item_select";
export const ON_FOLDER_SELECT = "on_folder_select";
export const ON_IMPORTANT_SELECT = "on_important_select";
export const ON_LABEL_MENU_ITEM_SELECT = "on_label_menu_item_select";
export const GET_MARK_AS_START = "get_mark_as_start";
export const ON_LABEL_SELECT = "on_label_select";
export const ON_MAIL_CHECKED = "on_mail_checked";
export const ON_MAIL_SELECT = "on_mail_select";
export const ON_MAIL_SEND = "on_mail_send";
export const ON_OPTION_MENU_ITEM_SELECT = "on_option_menu_item_select";
export const ON_OPTION_MENU_SELECT = "on_option_menu_select";
export const ON_START_SELECT = "on_start_select";
export const SEARCH_MAIL = "search_mail";
export const ON_DELETE_MAIL = "on_delete_mail";
export const SET_CURRENT_MAIL_NULL = "set_current_mail_null";
export const ON_COMPOSE_MAIL = "on_compose_mail";

//// TO-DO Module const

export const ON_SORTEND = "on_sortend";
export const FETCH_ALL_TODO = "fetch_all_todo";
export const FETCH_ALL_TODO_SUCCESS = "fetch_all_todo-success";
export const FETCH_ALL_TODO_CONVERSATION = "fetch_all_todo_conversation";
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS =
  "fetch_all_todo_conversation_success";
export const SELECT_ALL_TODO = "select_all_todo";
export const GET_ALL_TODO = "get_all_todo";
export const GET_UNSELECTED_ALL_TODO = "get_unselected_all_todo";
export const GET_STARRED_TODO = "get_starred_todo";
export const GET_UNSTARRED_TODO = "get_unstarred_todo";
export const GET_IMPORTANT_TODO = "get_important_todo";
export const GET_UNIMPORTANT_TODO = "get_unimportant_todo";
export const ON_LABEL_UPDATE = "on_label_update";
export const ON_TODO_UPDATE = "on_todo_update";
export const ON_DELETE_TODO = "on_delete_todo";
export const SEARCH_TODO = "search_todo";
export const SHOW_TODOS = "show_todos";
export const GET_TODO_CONVERSATION = "get_todo_conversation";
export const ON_TODO_CHECKED = "on_todo_checked";
export const ON_TODO_ADD = "on_todo_add";
export const ON_TODO_SELECT = "on_todo_select";
export const SET_CURRENT_TODO_NULL = "set_current_todo_null";
export const REMOVE_LABEL = "remove_label";
export const UPDATE_SEARCH = "update_search";

export const SET_YEAR_FILTER = "set_year_filter";
export const SET_LANGUAGE = "set_language";
export const SET_CURRENCY = "set_currency";

//Dashboard Filter
export const DASHBOARD_DISPLAY_FILTER = "dashboard_display_filter";
export const DASHBOARD_YEAR_FILTER = "dashboard_year_filter";
export const DASHBOARD_QUARTER_FILTER = "dashboard_quarter_filter";
export const DASHBOARD_MONTH_FILTER = "dashboard_month_filter";
export const DASHBOARD_SEARCH_TRIGGER = "dashboard_search_trigger";

//KPI
export const FETCH_KPI_PENDING = "fetch_kpi_pending";
export const FETCH_KPI_SUCCESS = "fetch_kpi_success";

//MapSaleByProvince
export const FETCH_SALE_PROVINCE_PENDING = "fetch_sale_province_pending";
export const FETCH_SALE_PROVINCE_SUCCESS = "fetch_sale_province_success";
export const FETCH_SALE_PROVINCE_FAILURE = "fetch_sale_province_failure";
export const MAP_FILTER = "map_filter";
export const MAP_YEAR_FILTER = "map_year_filter";

//Post Feed
export const FETCH_POST_SUCCESS = "fetch_post_success";
export const FETCH_POST_MORE_SUCCESS = "fetch_post_more_success";

//CustomerMainFilter
export const CUSTOMER_DISPLAY_FILTER = "customer_display_filter";
export const CUSTOMER_YEAR_FILTER = "customer_year_filter";
export const CUSTOMER_QTR_FILTER = "customer_qtr_filter";
export const CUSTOMER_MONTH_FILTER = "customer_month_filter";
export const CUSTOMER_GROUP_SELECT = "customer_group_select";
export const CUSTOMER_PROVINCE_SELECT = "customer_province_select";
export const CUSTOMER_MARKETPLACE_SELECT = "customer_marketplace_select";
export const CUSTOMER_GROUPTABLE_SELECT = "customer_grouptable_select";
export const CUSTOMER_SALE_PROD_CARD = "customer_sale_prod_card";
export const CUSTOMER_SALE_PROD = "customer_sale_prod";
export const CUSTOMER_SALE_PROD_MONTH = "customer_sale_prod_month";
export const CUSTOMER_NEWCUS_CARD = "customer_newcus_card";
export const CUSTOMER_NEWCUS_CHART = "customer_newcus_chart";
export const CUSTOMER_ACTIVE_CARD = "customer_active_card";
export const CUSTOMER_ACTIVE_CHART = "customer_active_chart";
export const CUSTOMER_AGING_CARD = "customer_aging_card";
export const CUSTOMER_AGING_CHART = "customer_aging_chart";
export const CUSTOMER_GROUP_FILTER = "customer_group_filter";



export const CUSTOMER_CODE_FILTER = "customer_code_filter";
export const NEW_CUSTOMER_FILTER = "new_customer_filter";
export const CUSTOMER_FORMATDISPLAY_FILTER = "customer_formatdisplay_filter";
export const CUSTOMER_PROVINCE_FILTER = "customer_province_filter";
export const CUSTOMER_MARKETPLACE_FILTER = "customer_marketplace_filter";
export const CUSTOMER_TYPE_FILTER = "customer_type_filter";

//CustomerListFilter
export const CUSTOMER_LIST_KEYWORD_FILTER = "customer_list_keyword_filter";

export const CUSTOMER_SEARCH_TRIGGER = "customer_search_trigger";

//CustomerFocusFilter
export const CUSTOMERFOCUS_DISPLAY_FILTER = "customerfocus_display_filter";
export const CUSTOMERFOCUS_YEAR_FILTER = "customerfocus_year_filter";
export const CUSTOMERFOCUS_QTR_FILTER = "customerfocus_qtr_filter";
export const CUSTOMERFOCUS_MONTH_FILTER = "customerfocus_month_filter";
export const CUSTOMERFOCUS_PRODUCTORDER_DISPLAY_FILTER =
  "customerfocus_productorder_display_filter";
export const CUSTOMERFOCUS_PRODUCTORDER_ITEMGROUP_FILTER =
  "customerfocus_productorder_itemgroup_filter";
export const CUSTOMERFOCUS_PRODUCTORDER_PRODUCTGROUP_FILTER =
  "customerfocus_productorder_productgroup_filter";
export const CUSTOMERFOCUS_PRODUCTORDER_PRODUCTLINE_FILTER =
  "customerfocus_productorder_productline_filter";
export const CUSTOMERFOCUS_SALESHISTORY_DISPLAY_FILTER =
  "customerfocus_saleshistory_display_filter";
export const CUSTOMERFOCUS_SALESHISTORY_AMOUNT_FILTER =
  "customerfocus_saleshistory_amount_filter";
export const CUSTOMERFOCUS_SALESHISTORY_ITEMGROUP_FILTER =
  "customerfocus_saleshistory_itemgroup_filter";
export const CUSTOMERFOCUS_SALESHISTORY_PRODUCTGROUP_FILTER =
  "customerfocus_saleshistory_productgroup_filter";
export const CUSTOMERFOCUS_SALESHISTORY_PRODUCTLINE_FILTER =
  "customerfocus_saleshistory_productline_filter";
export const CUSTOMERFOCUS_SALESHISTORY_PRODUCTTYPE_FILTER =
  "customerfocus_saleshistory_producttype_filter";

export const CUSTOMERFOCUS_SEARCH_TRIGGER = "customerfocus_search_trigger";

//Salesman
export const SALESMAN_PARENTSALESMAN_FILTER = "salesman_parentsalesman_filter";
export const SALESMAN_SALESAREA_FILTER = "salesman_salesarea_filter";
export const SALESMAN_SALESMANCODE_FILTER = "salesman_salesmancode_filter";
export const ROUTE_NO_FILTER = "route_no_filter";
export const SALESMAN_VISITPLAN_FILTER = "salesman_visitplan_filter";
export const SALESMAN_VISITPLAN_STATUS_FILTER =
  "salesman_visitplan_status_filter";
export const SALESMAN_DISPLAY_FILTER = "salesman_display_filter";
export const SALESMAN_PRODUCT_DISPLAY_FILTER =
  "salesman_product_display_filter";
export const SALESMAN_TEAM_DISPLAY_FILTER = "salesman_team_display_filter";

export const SALESMAN_SEARCH_TRIGGER = "salesman_search_trigger";
export const SALESMAN_PROJECTGROUP_FILTER = "salesman_projectgroup_filter";
export const SALESMAN_PROJECTTYPE_FILTER = "salesman_projecttype_filter";
export const SALESMAN_PROJECTCATEGORY_FILTER =
  "salesman_projectcategory_filter";
export const SALESMAN_PROJECTLINE_FILTER = "salesman_projectline_filter";
export const SALESMAN_PROJECT_STATUS_FILTER = "salesman_project_ststus_filter";
export const SALESMAN_PROJECT_STAGE_FILTER = "salesman_project_stage_filter";

export const SALESMAN_PROJECT_LIST_KEYWORD_FILTER =
  "salesman_project_list_keyword_filter";

//Product
export const PRODUCT_FILTER = "product_filter";
export const PRODUCT_ITEMGROUP_FILTER = "product_itemgroup_filter";
export const PRODUCT_PRODUCTGROUP_FILTER = "product_productgroup_filter";
export const PRODUCT_PRODUCTLINE_FILTER = "product_productline_filter";
export const PRODUCT_PRODUCTTYPE_FILTER = "product_producttype_filter";
export const PRODUCT_PRODUCTVATTYPE_FILTER = "product_productvattype_filter";
export const PRODUCT_DISPLAY_FILTER = "product_display_filter";
export const PRODUCT_AMOUNT_FILTER = "product_amount_filter";
export const PRODUCT_SALE_MONTH = "product_sale_month";
export const PRODUCT_NEW_PRODUCT = "product_new_product";
export const PRODUCT_DISPLAYSALESMAN_FILTER = "product_displaysalesman_filter";
export const PRODUCT_PRODUCTGROUP_FOCUS_FILTER =
  "product_productgroup_focus_filter";
export const PRODUCT_PRODUCTLINE_FOCUS_FILTER =
  "product_productline_focus_filter";
export const PRODUCT_PRODUCTTYPE_FOCUS_FILTER =
  "product_producttype_focus_filter";

export const PRODUCT_SEARCH_TRIGGER = "product_search_trigger";

//SalesFocus

export const SalesFocus_Invoice_CHART = "salesfocus_invoice_chart";

//Main
export const MAIN_COMPANY_FILTER = "main_company_filter";
export const MAIN_SALESORG_FILTER = "main_salesorg_filter";
export const MAIN_CHANNEL_FILTER = "main_channel_filter";
export const MAIN_IMPORT_COMPANY_FILTER = "main_import_company_filter";
export const MAIN_IMPORT_SALESORG_FILTER = "main_import_salesorg_filter";
export const MAIN_IMPORT_CHANNEL_FILTER = "main_import_channel_filter";
export const MAIN_DOCUMENT_TYPE_FILTER = "main_document_type_filter";

//Language change
export const FETCH_LANG_SUCCESS = "fetch_lang_success";
export const FETCH_LANG_MENU_SUCCESS = "fetch_lang_menu_success";
export const FETCH_LANG_DATE_FILTER_SUCCESS = "fetch_lang_date_filter_success";
export const FETCH_LANG_FULL_MONTH_SUCCESS = "fetch_lang_full_month_success";
export const FETCH_LANG_SHORT_MONTH_SUCCESS = "fetch_lang_short_month_success";
export const FETCH_LANG_MASTER_SUCCESS = "fetch_lang_master_success";
export const FETCH_LANG_DASHBOARD_SUCCESS = "fetch_lang_dashboard_success";
export const FETCH_LANG_CUSTOMER_SUCCESS = "fetch_lang_customer_success";
export const FETCH_LANG_CUSTOMER_FOCUS_SUCCESS =
  "fetch_lang_customer_focus_success";

//Filter
export const KEYWORD_FILTER = "keyword_filter";
export const START_DATE_FILTER = "start_date_filter";
export const END_DATE_FILTER = "end_date_filter";
export const DOC_STATUS_FILTER = "doc_status_filter";

//Report
export const REPORT_PLANT_FILTER = "report_plant_filter";
export const REPORT_LOCATIONTYPE_FILTER = "report_locationtype_filter";
export const REPORT_PRODUCT_FILTER = "report_product_filter";
export const REPORT_STARTDATE_FILTER = "report_startdate_filter";
export const REPORT_ENDDATE_FILTER = "report_enddate_filter";
export const REPORT_TYPE_FILTER = "report_type_filter";
export const REPORT_BILLING_TYPE_FILTER = "report_billing_type_filter";
export const REPORT_MOVEMENT_TYPE_FILTER = "report_movement_type_filter";
export const REPORT_FROM_PLANT_FILTER = "report_from_plant_filter";
export const REPORT_TO_PLANT_FILTER = "report_to_plant_filter";
export const REPORT_UNIT_FILTER = "report_unit_filter";
export const REPORT_COPY_ORIGINAL_SELECTED = "report_copy_original_selected";

export const REPORT_SEARCH_TRIGGER = "report_search_trigger";

// OrderTransaction
export const ORDER_TRANSACTION_DOC_NUMBER_FILTER = "order_transaction_doc_number_filter";
export const ORDER_TRANSACTION_DOC_NUMBER_INV_FILTER = "order_transaction_doc_number_inv_filter";
export const ORDER_TRANSACTION_DOC_NUMBER_REF_FILTER = "order_transaction_doc_number_ref_filter";
export const ORDER_TRANSACTION_SHOW_ONLY_LAST_REF = "order_transaction_show_only_last_ref";
export const ORDER_TRANSACTION_SHIP_START_DATE_FILTER = "order_transaction_ship_start_date_filter";
export const ORDER_TRANSACTION_SHIP_TO_DATE_FILTER = "order_transaction_ship_to_date_filter";

// SupplierPOTransaction
export const SUPPLIER_PO_TRANSACTION_DOC_NUMBER_FILTER = "supplier_po_transaction_doc_number_filter";
export const SUPPLIER_PO_TRANSACTION_DOC_NUMBER_INV_FILTER = "supplier_po_transaction_doc_number_inv_filter";
export const SUPPLIER_PO_TRANSACTION_DOC_NUMBER_REF_FILTER = "supplier_po_transaction_doc_number_ref_filter";

// SupplierPRTransaction
export const SUPPLIER_PR_TRANSACTION_DOC_NUMBER_FILTER = "supplier_pr_transaction_doc_number_filter";
export const SUPPLIER_PR_TRANSACTION_DOC_NUMBER_INV_FILTER = "supplier_pr_transaction_doc_number_inv_filter";
export const SUPPLIER_PR_TRANSACTION_DOC_NUMBER_REF_FILTER = "supplier_pr_transaction_doc_number_ref_filter";

// SupplierReturn
export const SUPPLIER_RETURN_DOC_NUMBER_FILTER = "supplier_return_doc_number_filter";
export const SUPPLIER_RETURN_DOC_NUMBER_INV_FILTER = "supplier_return_doc_number_inv_filter";
export const SUPPLIER_RETURN_DOC_NUMBER_REF_FILTER = "supplier_return_doc_number_ref_filter";

// QuotationTransaction
export const QUOTATION_TRANSACTION_DOC_NUMBER_FILTER = "quotation_transaction_doc_number_filter";
export const QUOTATION_TRANSACTION_DOC_NUMBER_ORDER_FILTER = "quotation_transaction_doc_number_order_filter";
export const QUOTATION_TRANSACTION_DOC_NUMBER_REF_FILTER = "quotation_transaction_doc_number_ref_filter";
export const QUOTATION_TRANSACTION_SHOW_ONLY_MAX_REVISION = "quotation_transaction_show_only_max_revision";


// ReturnTransaction
export const RETURN_TRANSACTION_DOC_NUMBER_FILTER =
  "return_transaction_doc_number_filter";
export const RETURN_TRANSACTION_DOC_REF_NUMBER_FILTER =
  "return_transaction_doc_ref_number_filter";
export const RETURN_TRANSACTION_BILL_REF_NO_FILTER =
  "return_transaction_bill_ref_no_filter";

// CreditNoteTransaction
export const CREDIT_NOTE_TRANSACTION_DOC_NUMBER_FILTER =
  "credit_note_transaction_doc_number_filter";
export const CREDIT_NOTE_TRANSACTION_DOCUMENT_TYPE_SELECTED =
  "credit_note_transaction_document_type_selected";
export const CREDIT_NOTE_TRANSACTION_DOC_HEADER_SELECTED =
  "credit_note_transaction_doc_header_type_selected";

// InvoiceTransaction
export const INVOICE_TRANSACTION_DOC_NUMBER_FILTER = "invoice_transaction_doc_number_filter";
export const INVOICE_TRANSACTION_DOCUMENT_TYPE_FILTER = "invoice_transaction_document_type_filter";

// ReceiptTransaction
export const RECEIPT_TRANSACTION_DOC_NUMBER_FILTER = "receipt_transaction_doc_number_filter";

//AR Report
export const AR_REPORT_DOC_NUMBER_FILTER = "ar_arport_doc_number_filter";
export const AR_REPORT_DOC_STATUS_FILTER = "ar_report_doc_status_filter";

// Notification
export const SET_ALERT_NOTIFICATION = "set_alert_notification";

// สั่งให้ SideNav ดึง NotificationCount ของเมนูใหม่ (เช่น หลัง Complete/ลบ/สร้างเอกสาร)
export const MENU_NOTIFICATION_REFRESH = "menu_notification_refresh";

export const EXPENSE_REPORT_DOC_NUMBER_FILTER = "expense_report_doc_number_filter";

export const EXPENSE_DOC_NUMBER_FILTER = "expense_doc_number_filter";

export const EXPENSE_TYPE_FILTER = "expense_type_filter";

export const EXPENSE_TRANSACTION_STATUS_FILTER = "expense_transaction_status_filter";

export const STOCK_TRANSACTION_DOC_NUMBER_FILTER = "stock_transaction_doc_number_filter";

export const SUPPLIER_FILTER = "supplier_filter";
export const SUPPLIER_TYPE_FILTER = "supplier_type_filter";




// เมนู Salesman Master (พนักงานขาย + เขตการขาย)
export const SALESMAN_MASTER_KEYWORD_FILTER = "salesman_master_keyword_filter";
